<template>
  <div class="container top-level-div" v-if="this.$store.getters.isEmployer !== true">
    <!-- <h1 ref="pageTitle">Opportunities</h1> -->
    <div class="center">
      <h3>YOUR NEXT OPPORTUNITY AWAITS</h3>
      <strong>We have countless positions available at any given time, and share new opportunities daily!</strong>
      <p>Check out our current openings below and be sure to read the jobs descriptions carefully! Please be sure that you meet those qualifications outlined and are comfortable with the commute, hours, duties and rate prior to expressing interest in a position.</p>
    </div>
    <hr>
    <!-- <div v-if="jobs.length > 0" class="mb-1">
      <app-map-board :items="jobs"></app-map-board>
    </div> -->

    <div v-if="auth" class="mb-5">
      <h3>Sitter Opportunities</h3>
      <div class="calendar" style="display: flex; flex-direction: column; flex-grow: 1; min-height: 600px;">
        <calendar-view
          :show-date="showDate"
          class="theme-default holiday-us-traditional holiday-us-official"
          @click-date="onClickDate"
          :date-classes="selectedDateObj"
          :events="calendarJobs"
          @click-event="onClickEvent"
        >
          <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="setShowDate"
          />
        </calendar-view>
      </div>
    </div>

    <h3 class="mt-4">Full Time Opportunities</h3>
    <hr>
    <div v-if="jobs.length > 0">
      <app-job-list :jobs="jobsLongTerm"></app-job-list>
    </div>

    <modal name="job-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" style="">
        <job :passedID="job.id" style="margin-top: -15vh; margin-bottom: -20vh;"></job>
        <hr>
        <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('application-submitted-modal')" style="">Close</button> -->
        <button class="mylisting-button secondary-button" @click="$modal.hide('job-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import JobList from '../employers/jobs/JobList'
  import MapBoard from '../global/MapBoard'
  import Job from './Job'

  import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
  require("vue-simple-calendar/static/css/default.css");

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    data() {
      return {
        jobsLongTerm: [],

        jobs: [],
        calendarJobs: [],
        job: {},
        jobPoster: {},
        showDate: new Date(),
        selectedDateObj: {},
      }
    },
    components: {
      appJobList: JobList,
      appMapBoard: MapBoard,
      CalendarView,
      CalendarViewHeader,
      Job,
    },
    created() {
      // console.log('Job Board Created')
      this.getJobs()

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
      },3500)

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    // mounted() {
    //   document.title = this.$refs.pageTitle.innerHTML
    // },
    methods: {
      getJobs() {
        // Long Term Jobs
        axios.get('/api/jobs/?job_type=Long Term&agency='+this.$store.getters.agencyID)
          .then(res => {
            this.jobsLongTerm = res.data
            this.jobsLongTerm = this.jobsLongTerm.sort((a, b) => (a.id < b.id) ? 1 : -1)

            // Only want to show jobs where the application deadline hasn't passed
            var activePostings = []
            let rightNow = new Date()
            for (var job in this.jobsLongTerm) {
              // if (this.jobs[job].application_deadline) {
                // if (((new Date(this.jobs[job].application_deadline)) >= rightNow) && this.jobs[job].status !== 'draft') {
                if (this.jobsLongTerm[job].status != 'Closed') {
                  activePostings.push(this.jobsLongTerm[job])
                }
              // }
            }
            this.jobsLongTerm = activePostings

            // console.log(this.jobs)
          })
          .catch(error => console.log(error))

        // Short term calendar jobs
        axios.get(`/api/jobs/?job_type=Short Term&agency=${this.$store.getters.agencyID}`)
          .then(res => {
            console.log(res)
            this.jobs = res.data
            this.jobs = this.jobs.sort((a, b) => (a.date < b.date) ? 1 : -1)

            this.calendarJobs = []

            for (var job in this.jobs) {
              // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'title': `${this.jobs[job].start_time} - ${this.jobs[job].end_time}`})
              // this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})

              // if (!(this.filterFamilyOptions.includes(this.jobs[job].poster_name))){
              //   this.filterFamilyOptions.push(this.jobs[job].poster_name)
              // }
              // this.filterFamilyOptions= this.filterFamilyOptions.sort()

              // If the job is filled, get the candidate who is filling the job
              // let candidate = null
              // if (this.jobs[job].filler) {
              //   candidate = this.candidates.filter(element => {
              //     return element.id == this.jobs[job].filler;
              //   })[0];
              // }

              if (this.jobs[job].status == 'Requested') {
                this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #FFB6C1; background-color: #FFB6C1;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)}`})
              }
              else if (this.jobs[job].status == 'Pending') {
                this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #FFB6C1; background-color: #FFB6C1;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)}`})
              }
              // else if (this.jobs[job].status == 'Assigned') {
              //   this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; ', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})
              //   // let candidate = this.candidates.filter(element => {
              //   //   return element.id == this.jobs[job].filler;
              //   // })[0];
              //   // console.log(candidate)
              //   // console.log(this.candidates.indexOf(candidate))
              //   // console.log(this.candidates[this.candidates.indexOf(candidate)])
              //   this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; ', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
              // }
              // else if (this.jobs[job].status == 'In Progress') {
              //   this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #6dc96d; background-color: #6dc96d;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})
              //   // let candidate = this.candidates.filter(element => {
              //   //   return element.id == this.jobs[job].filler;
              //   // })[0];
              //   this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #6dc96d; background-color: #6dc96d;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
              // }
              // else if (this.jobs[job].status == 'Completed') {
              //   this.calendarJobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status} - ${this.jobs[job].filler_name})`})

              //   this.candidates[this.candidates.indexOf(candidate)].jobs.push({'id': this.jobs[job].id, 'startDate': `${this.jobs[job].date} ${this.jobs[job].start_time}`, 'endDate': `${this.jobs[job].date} ${this.jobs[job].end_time}`, 'style': 'white-space: normal; border-color: #f5f5dc; background-color: #f5f5dc;', 'title': `${this.jobs[job].poster_name} ${this.djangotimeformatAMPM(this.jobs[job].start_time)} - ${this.djangotimeformatAMPM(this.jobs[job].end_time)} (${this.jobs[job].status})`})
              // }
            }

          })
          .catch(error => {
            console.log(error)
          })
      },
      setShowDate(d) {
        this.showDate = d;
      },
      onClickDate(d) {
        console.log('date clicked')
        console.log(d)
        this.selectedDate = d

        // this.currentStep = 1;
        // this.selectedStartDate = d;
        // // this.selectedStartDate = d.toISOString().substring(0, 10);
        // this.selectedDateObj = {
        //   [this.selectedStartDate]: "ClassForSelectedDate"
        // };
        // console.log("selected date", this.selectedDateObj);
      },
      getJobPoster() {
        axios.get(`/api/people/?id=${this.job.poster}`)
          .then(res => {
            this.jobPoster = res.data[0]
          })
          .catch(error => console.log(error))
      },
      onClickEvent(event) {
        // console.log(event)
        axios.get(`/api/jobs/?id=${event.id}`)
          .then(res => {
            // console.log(res)
            this.job = res.data[0]
            this.job.date = this.addCurrentTimeToDate(this.job.date)
            this.status = this.job.status

            // this.getApplications(this.job)
            // axios.get(`/api/jobapplications/?job=${this.job.id}`)
            //   .then(res => {
            //     console.log(res)
            //     this.applications = res.data

            //     this.$modal.show('job-modal')
            //   })
            //   .catch(error => console.log(error))
            this.getJobPoster()
            this.$modal.show('job-modal')
          })
          .catch(error => console.log(error))
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/jobBoard/JobBoard.vue